import { render, staticRenderFns } from "./selectTag.vue?vue&type=template&id=5f041026"
import script from "./selectTag.vue?vue&type=script&lang=js"
export * from "./selectTag.vue?vue&type=script&lang=js"
import style0 from "./selectTag.vue?vue&type=style&index=0&id=5f041026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports